import React from 'react';
import styled from 'styled-components';

import { translate } from '~/services/translate';
import { ColumnFlexCentered } from '~/components/basic/containers';
import Anchor from '~/components/basic/anchor';
import mainTheme from '~/core/theme';
import analytics from '~/services/amplitude';

const Container = styled(ColumnFlexCentered)`
  width: 388px;
  align-items: flex-start;
  color: ${mainTheme.lightFont};
`;

const Title = styled.div`
  font-size: 40px;
  font-family: 'Inter', sans-serif;
`;

const Subtitle = styled.div`
  font-size: 19px;
  font-family: 'Inter', sans-serif;
  margin-top: 24px;
`;

const trackPageView = () => {
   analytics.trackPageView(analytics.PAGE_NAMES.LEARN_MORE);
}

const DefaultVpaaS = () => (
  <Container>
    <Title>{translate('vpaas_default_add_title')}</Title>
    <Subtitle>{translate('vpaas_default_add_subtitle')}</Subtitle>
    <Anchor href={JAAS_URL} target="_blank" onClick={ trackPageView }>
      <Subtitle><u>{translate('learn_more')}</u></Subtitle>
    </Anchor>
  </Container>
)

export default DefaultVpaaS;
